<template>
  <div>
    <ClientOnly>
      <iframe
        class="w-full h-full"
        :class="[extraClasses]"
        width="100%"
        :src="videoUrl"
        :data-cmp-src="dataCmpSrc"
        :data-cmp-vendor="dataCmpVendor"
        :data-cmp-purpose="dataCmpPurpose"
        :type="typeOfContent"
        allow="accelerometer; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      />
    </ClientOnly>
  </div>
</template>

<script lang="ts">

export default defineComponent({
  name: 'VideoIframe',
  props: {
    videoUrl: {
      type: String,
      required: true,
    },
    extraClasses: {
      type: String,
      default: '',
    },
    dataCmpSrc: {
      type: String,
      default: '',
    },
    typeOfContent: {
      type: String,
      default: 'text/plain',
    },
    dataCmpVendor: {
      type: String,
      default: '',
    },
    dataCmpPurpose: {
      type: String,
      default: '',
    },
  },
});

</script>
